/**
 *  接口返回的Json对象
 */
export default class ResponseJson {
  constructor () {
    this.JsonResult = true  //返回结果
    this.JsonMessage = {}   //返回消息
    this.JsonData = []      //返回数据
  }

  /*
   * 取节点Row的数据
   */
  Row (_sid) {
    for (let _jsonData of this.JsonData) {
      if (_jsonData.SQLBuilderID === _sid) {
        return _jsonData.ROW
      }
    }
    return []
  }
}



// WEBPACK FOOTER //
// ./src/wbap-core-commit/model/ResponseJson.js